import React, { memo } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash-es';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Nav from 'reactstrap/lib/Nav';
import { URL_PATHS } from 'site-modules/shared/constants/appraisal/paths';
import { AiNavigationLink } from './ai-navigation-link';
import { GlobalNavLink } from './global-nav-link';

import './navigation-links.scss';

const GENERAL_LINKS = [
  {
    titlePostfix: 'Car Pricing',
    title: 'New',
    trackingId: 'global_nav_select_new_car',
    url: '/new-cars/',
  },
  {
    titlePostfix: 'Cars for Sale',
    title: 'Used',
    trackingId: 'global_nav_select_used_car',
    url: '/used-cars-for-sale/',
  },
];

const SEOT_4353_LINKS = [
  {
    titlePostfix: 'Cars for Sale',
    title: 'New',
    trackingId: 'global_nav_select_new_car',
    url: '/new-cars/',
  },
  {
    titlePostfix: 'Cars for Sale',
    title: 'Used',
    trackingId: 'global_nav_select_used_car',
    url: '/used-cars-for-sale/',
  },
];

const HOME_LINK = {
  title: 'Home',
  trackingId: 'global_nav_homepage_click',
  url: '/',
};

const APPRAISAL_LINK = {
  title: 'My Car Value',
  trackingId: 'appraisal_link_tool_select',
  url: URL_PATHS.APPRAISAL_LANDING,
  smallScreenTitle: 'Appraise',
  attributes: {
    'data-tracking-value': 'My Car Value',
  },
};

const REVIEW_LINK = {
  titlePrefix: 'Car',
  title: 'Reviews',
  trackingId: 'link_select_tool_select',
  url: '/car-reviews/',
};

function getLinksToRender({
  renderGeneralLinks,
  renderHomeLink,
  renderAppraisalLink,
  reverseAppendedLinks,
  isSEOT4353Enabled,
  renderAiLink,
}) {
  const generalLinks = renderGeneralLinks ? [...GENERAL_LINKS] : [];
  let links = isSEOT4353Enabled ? [...SEOT_4353_LINKS] : generalLinks;

  if (renderHomeLink) {
    links = [HOME_LINK, ...links];
  }
  const linksToAppend = [REVIEW_LINK];
  if (renderAppraisalLink) {
    linksToAppend.push(APPRAISAL_LINK);
  }

  if (!reverseAppendedLinks) linksToAppend.reverse();

  if (renderAiLink) {
    linksToAppend.push({ component: AiNavigationLink });
  }

  return [...links, ...linksToAppend];
}

export const mapStateToProps = state => ({
  enableSeot4353GlobalNavUpdate: !!get(state, 'featureFlags.enable-seot-4353-global-nav-update'),
  enableSeot4597GlobalNavMobileUpdate: !!get(state, 'featureFlags.enable-seot-4597-global-nav-mobile-update'),
});

export const NavigationLinks = connect(mapStateToProps)(
  memo(
    ({
      renderHomeLink = false,
      renderGeneralLinks = true,
      pathname = '',
      className = '',
      renderAppraisalLink = true,
      displayFullLinksText = false,
      isMobile = false,
      enableSeot4353GlobalNavUpdate = false,
      enableSeot4597GlobalNavMobileUpdate = false,
      withAiLink = true,
      use2027Theme = false,
    }) => {
      const renderAiLink = withAiLink && isMobile;
      return (
        <div
          className={classnames({
            'w-100': !!className && !withAiLink,
          })}
        >
          <Nav className={classnames('navigation-links m-0 p-0', className)}>
            {getLinksToRender({
              renderGeneralLinks,
              renderHomeLink,
              renderAppraisalLink,
              reverseAppendedLinks: isMobile && !enableSeot4597GlobalNavMobileUpdate,
              isSEOT4353Enabled: enableSeot4353GlobalNavUpdate,
              renderAiLink,
            }).map((link, index) => {
              const Component = link.component || GlobalNavLink;
              return (
                <Component
                  link={link}
                  pathname={pathname}
                  key={link.url || `custom-link-${index}`}
                  displayFullLinksText={displayFullLinksText}
                  isMobile={isMobile}
                  enableSeot4597GlobalNavMobileUpdate={enableSeot4597GlobalNavMobileUpdate}
                  globalNavLinkClasses={use2027Theme ? 'global-nav-link text-cool-gray-10' : undefined}
                  use2027Theme={use2027Theme}
                />
              );
            })}
          </Nav>
        </div>
      );
    }
  )
);

NavigationLinks.propTypes = {
  pathname: PropTypes.string,
  renderHomeLink: PropTypes.bool,
  renderGeneralLinks: PropTypes.bool,
  className: PropTypes.string,
  renderAppraisalLink: PropTypes.bool,
  displayFullLinksText: PropTypes.bool,
  isMobile: PropTypes.bool,
  enableSeot4353GlobalNavUpdate: PropTypes.bool,
  enableSeot4597GlobalNavMobileUpdate: PropTypes.bool,
  withAiLink: PropTypes.bool,
  use2027Theme: PropTypes.bool,
};

NavigationLinks.displayName = 'NavigationLinks';
